!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("prop-types"), require("@leafygreen-ui/emotion"));else if ("function" == typeof define && define.amd) define(["react", "prop-types", "@leafygreen-ui/emotion"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : t(e.react, e["prop-types"], e["@leafygreen-ui/emotion"]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t, r) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var l = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(l.exports, l, l.exports, r), l.l = !0, l.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var l in e) {
        r.d(n, l, function (t) {
          return e[t];
        }.bind(null, l));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 2);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "createIconComponent", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    }), Object.defineProperty(t, "Size", {
      enumerable: !0,
      get: function get() {
        return i.Size;
      }
    }), Object.defineProperty(t, "glyphs", {
      enumerable: !0,
      get: function get() {
        return a.default;
      }
    }), t.default = void 0;

    var l,
        i = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var t = o();
      if (t && t.has(e)) return t.get(e);
      var r = {},
          l = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var i in e) {
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          var a = l ? Object.getOwnPropertyDescriptor(e, i) : null;
          a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
        }
      }

      r.default = e, t && t.set(e, r);
      return r;
    }(r(3)),
        a = (l = r(4)) && l.__esModule ? l : {
      default: l
    };

    function o() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return o = function o() {
        return e;
      }, e;
    }

    var u = (0, i.default)(a.default);
    t.default = u;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      var t = function t(_t) {
        var r = _t.glyph,
            l = function (e, t) {
          if (null == e) return {};

          var r,
              n,
              l = function (e, t) {
            if (null == e) return {};
            var r,
                n,
                l = {},
                i = Object.keys(e);

            for (n = 0; n < i.length; n++) {
              r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
            }

            return l;
          }(e, t);

          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);

            for (n = 0; n < i.length; n++) {
              r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
            }
          }

          return l;
        }(_t, ["glyph"]),
            i = e[r];

        return n.default.createElement(i, l);
      };

      return t.displayName = "Icon", t.propTypes = {
        glyph: l.default.oneOf(Object.keys(e)).isRequired,
        size: l.default.oneOfType([l.default.oneOf(Object.values(a)), l.default.number])
      }, t;
    }, t.Size = void 0;
    var n = i(r(0)),
        l = i(r(1));

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = {
      Small: "small",
      Default: "default",
      Large: "large",
      XLarge: "xlarge"
    };
    t.Size = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var n = oe(r(5)),
        l = oe(r(7)),
        i = oe(r(8)),
        a = oe(r(9)),
        o = oe(r(10)),
        u = oe(r(11)),
        c = oe(r(12)),
        f = oe(r(13)),
        v = oe(r(14)),
        p = oe(r(15)),
        d = oe(r(16)),
        s = oe(r(17)),
        y = oe(r(18)),
        h = oe(r(19)),
        b = oe(r(20)),
        O = oe(r(21)),
        g = oe(r(22)),
        m = oe(r(23)),
        j = oe(r(24)),
        w = oe(r(25)),
        E = oe(r(26)),
        P = oe(r(27)),
        x = oe(r(28)),
        z = oe(r(29)),
        I = oe(r(30)),
        S = oe(r(31)),
        M = oe(r(32)),
        H = oe(r(33)),
        C = oe(r(34)),
        V = oe(r(35)),
        k = oe(r(36)),
        B = oe(r(37)),
        R = oe(r(38)),
        L = oe(r(39)),
        A = oe(r(40)),
        _ = oe(r(41)),
        D = oe(r(42)),
        W = oe(r(43)),
        T = oe(r(44)),
        N = oe(r(45)),
        q = oe(r(46)),
        U = oe(r(47)),
        G = oe(r(48)),
        X = oe(r(49)),
        F = oe(r(50)),
        $ = oe(r(51)),
        Q = oe(r(52)),
        Z = oe(r(53)),
        J = oe(r(54)),
        K = oe(r(55)),
        Y = oe(r(56)),
        ee = oe(r(57)),
        te = oe(r(58)),
        re = oe(r(59)),
        ne = oe(r(60)),
        le = oe(r(61)),
        ie = oe(r(62)),
        ae = oe(r(63));

    function oe(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var ue = {
      ActivityFeed: l.default,
      ArrowDown: i.default,
      ArrowLeft: a.default,
      ArrowRight: o.default,
      ArrowUp: u.default,
      Copy: c.default,
      Beaker: f.default,
      Bell: v.default,
      Building: d.default,
      Bulb: p.default,
      CaretUp: s.default,
      CaretDown: y.default,
      CaretRight: h.default,
      CaretLeft: b.default,
      Checkmark: O.default,
      CheckmarkWithCircle: g.default,
      ChevronUp: m.default,
      ChevronDown: j.default,
      ChevronRight: w.default,
      ChevronLeft: E.default,
      Charts: P.default,
      Cloud: x.default,
      CreditCard: z.default,
      Edit: I.default,
      Ellipsis: S.default,
      Folder: M.default,
      GovernmentBuilding: H.default,
      ImportantWithCircle: C.default,
      InfoWithCircle: V.default,
      InviteUser: k.default,
      Laptop: B.default,
      Lock: R.default,
      MagnifyingGlass: L.default,
      Megaphone: A.default,
      Menu: _.default,
      NotAllowed: D.default,
      OpenNewTab: W.default,
      Person: T.default,
      PersonWithLock: N.default,
      Plus: q.default,
      PlusWithCircle: U.default,
      QuestionMarkWithCircle: G.default,
      Refresh: X.default,
      Save: F.default,
      Settings: $.default,
      SortAscending: Q.default,
      SortDescending: Z.default,
      Stitch: J.default,
      Support: K.default,
      Trash: Y.default,
      University: ee.default,
      Unsorted: te.default,
      UpDownCarets: re.default,
      VerticalEllipsis: ne.default,
      Warning: le.default,
      X: ie.default,
      XWithCircle: ae.default
    },
        ce = Object.keys(ue).reduce(function (e, t) {
      return e[t] = (0, n.default)(t, ue[t]), e;
    }, {});
    t.default = ce;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getGlyphTitle = p, t.default = function (e, t) {
      function r(r) {
        var l = r.className,
            a = r.size,
            d = void 0 === a ? f.Default : a,
            s = r.title,
            y = r.fill,
            h = function (e, t) {
          if (null == e) return {};

          var r,
              n,
              l = function (e, t) {
            if (null == e) return {};
            var r,
                n,
                l = {},
                i = Object.keys(e);

            for (n = 0; n < i.length; n++) {
              r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
            }

            return l;
          }(e, t);

          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);

            for (n = 0; n < i.length; n++) {
              r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
            }
          }

          return l;
        }(r, ["className", "size", "title", "fill"]),
            b = (0, i.css)(c(), y),
            O = "number" == typeof d ? d : v[d];

        return n.default.createElement(t, o({
          className: (0, i.cx)(u({}, b, null != y), l),
          title: p(e, s),
          height: O,
          width: O
        }, h));
      }

      return r.displayName = e, r.isGlyph = !0, r.propTypes = {
        fill: l.default.string,
        size: l.default.oneOfType([l.default.oneOf(Object.values(f)), l.default.number]),
        className: l.default.string
      }, r;
    }, t.Size = void 0;
    var n = a(r(0)),
        l = a(r(1)),
        i = r(6);

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o() {
      return (o = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function u(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function c() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n      color: ", ";\n    "]);

      return c = function c() {
        return e;
      }, e;
    }

    var f = {
      Small: "small",
      Default: "default",
      Large: "large",
      XLarge: "xlarge"
    };
    t.Size = f;
    var v = {
      small: 14,
      default: 16,
      large: 20,
      xlarge: 24
    };

    function p(e, t) {
      return !1 === t ? null : null == t || !0 === t ? "".concat(e.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon") : t;
    }
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9.97 8.058a.984.984 0 01.919.612l.005.012.003.01.028.086 1.11 3.952.129-.189a.996.996 0 01.698-.427h.019l.093-.007h3.01v1.984h-2.475l-1.03 1.517a.984.984 0 01-.818.433.989.989 0 01-.921-.614l-.004-.01-.001-.008-.03-.086-.905-3.219-.557 1.368a.989.989 0 01-.8.611l-.008.001-.01.001-.09.006H6v-1.984h1.657l1.396-3.43a.982.982 0 01.917-.619zM11.984 0v7.258H10V1.994H1.984v10.111H4.65V14.1H0V0h11.984zM6.325 6.384v1.333H3.212V6.384h3.113zm2.446-2.666V5.05H3.212V3.718h5.559z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M1.938 6.952l-.712.694a.734.734 0 000 1.06l6.229 6.074a.78.78 0 001.087 0l6.232-6.075a.734.734 0 000-1.059l-.712-.694a.784.784 0 00-1.1.013l-3.68 3.765V1.75a.758.758 0 00-.77-.75H7.488a.758.758 0 00-.77.75v8.98l-3.68-3.765a.779.779 0 00-1.1-.013z",
      fill: "currentColor",
      fillRule: "nonzero"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9.048 1.938l-.694-.712a.734.734 0 00-1.06 0L1.22 7.455a.78.78 0 000 1.087l6.075 6.232a.734.734 0 001.059 0l.694-.712a.784.784 0 00-.013-1.1L5.27 9.283h8.98c.416 0 .75-.343.75-.77V7.488a.758.758 0 00-.75-.77H5.27l3.765-3.68a.779.779 0 00.013-1.1z",
      fill: "currentColor",
      fillRule: "nonzero"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M6.952 1.938l.694-.712a.734.734 0 011.06 0l6.074 6.229a.78.78 0 010 1.087l-6.075 6.232a.734.734 0 01-1.059 0l-.694-.712a.784.784 0 01.013-1.1l3.765-3.68H1.75a.758.758 0 01-.75-.77V7.488c0-.426.334-.77.75-.77h8.98l-3.765-3.68a.779.779 0 01-.013-1.1z",
      fill: "currentColor",
      fillRule: "nonzero"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M14.062 9.048l.712-.694a.734.734 0 000-1.06L8.545 1.22a.78.78 0 00-1.087 0L1.226 7.295a.734.734 0 000 1.059l.712.694a.784.784 0 001.1-.013l3.68-3.765v8.98c0 .416.343.75.77.75h1.025c.426 0 .77-.334.77-.75V5.27l3.68 3.765a.779.779 0 001.1.013z",
      fill: "currentColor",
      fillRule: "nonzero"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M13 5h-3V2H7v9h6V5zm2 0v8H5V0h5l5 5z"
    }), n.createElement("path", {
      d: "M4 4v1H2v10h7v-1h1v2H1V4h3z"
    }));

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M10.623 1a.886.886 0 01.041 1.772V5.34c0 .114.035.239.095.343l3.516 5.647.002.003c.232.387.356.818.356 1.254 0 .4-.106.804-.318 1.17l-.003.006-.004.007-.095.158A2.36 2.36 0 0112.217 15h-8.4c-.44 0-.86-.118-1.22-.333a2.448 2.448 0 01-.875-.904l-.001-.003a2.428 2.428 0 01-.301-1.163c0-.438.123-.877.367-1.268l3.53-5.647a.695.695 0 00.094-.343V2.772A.885.885 0 015.452 1zM8.904 2.774H7.185V5.34c0 .457-.136.892-.365 1.27l-.001.001-3.522 5.657a.644.644 0 00-.103.343c0 .102.026.2.081.296l.003.005a.62.62 0 00.553.329h8.4c.12 0 .223-.031.316-.087a.675.675 0 00.238-.898L9.272 6.612a2.324 2.324 0 01-.368-1.273V2.774zm.606 6.633l1.553 2.49a.227.227 0 01.01.243.223.223 0 01-.206.122H5.195c-.122 0-.187-.075-.206-.122-.028-.056-.056-.15.01-.243l1.553-2.49H9.51z",
      fill: "currentColor"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M14.934 13.25h-4.118a3.005 3.005 0 01-2.828 2 3.005 3.005 0 01-2.828-2H1.066l1.07-2.734c.43-1.086.837-2.414.852-2.774v-.031c.016-2.234.336-4.406 3.625-4.867A1.496 1.496 0 017.988.75a1.5 1.5 0 011.383 2.086c.922.117 1.86.414 2.563 1.125 1.086 1.102 1.07 2.539 1.054 3.797.016.367.422 1.68.844 2.75l1.102 2.742zm-9.946-5.5c-.008 1-.992 3.5-.992 3.5h7.984s-1-2.5-.992-3.5c.024-2 0-3-3-3s-2.992 1-3 3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M12.8 14.3c-.1.2-.2.5-.3.7-.1.1-.2.3-.3.3h-.1l-2.4.6c-.2.1-.4 0-.6-.1-.2-.2-.4-.3-.5-.5l4.2-1zm-.2-2.2c.1 0 .1.1 0 0 .1.5.2.9.4 1.2l-5.1 1.3c-.1-.4-.2-.8-.3-1.1v-.1c1.6-.4 3.3-.8 5-1.3zM5.5.5C6.6 0 7.8-.1 9 .1c1.5.3 2.7 1 3.7 2.1.5.6.9 1.3 1 2.1.3 1.2.2 2.3-.4 3.4-.4.8-.7 1.6-.9 2.5-.1.3-.1.6-.1.9 0 0 0 .1-.1.1-.5.1-.9.2-1.4.4h-.1c-.1-.2-.1-.3-.1-.5.1-1.3.4-2.6 1.1-3.8.4-.7.5-1.4.4-2.2-.2-1.1-.7-2-1.6-2.7-.8-.6-1.8-.9-2.9-.8-1 .1-1.9.4-2.7 1.1-.8.8-1.2 1.8-1.1 3.1.1 1.2.7 2.3 1.8 3 1.2.8 2.2 1.7 2.9 2.8.1.1.2.3.2.4-.4.1-.7.2-1.1.3-.1 0-.3.1-.4.1h-.1c-.6-.8-1.3-1.5-2.1-2.1-.3-.2-.6-.4-.8-.6-.7-.5-1.2-1.2-1.5-2C1.9 6 2 4.3 3 2.6 3.6 1.7 4.4 1 5.5.5zm1.6 2.1c.3-.1.5 0 .7.2.2.3 0 .6-.3.7-.4.2-.8.4-1.1.7-.4.4-.6.9-.5 1.5 0 .1 0 .2.1.3 0 .2 0 .4-.2.5-.2.2-.4.2-.6.1-.1 0-.2-.2-.3-.3-.2-.9-.1-1.7.5-2.5.3-.5.8-.8 1.3-1.1.1 0 .1 0 .2-.1.1.1.1.1.2 0z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M10 4h4v11H1V1h9v3zM3 3v10h5V3H3zm1 3V4h1v2H4zm2 0V4h1v2H6zm3 0v7h3V6H9zM4 9V7h1v2H4zm2 0V7h1v2H6zm4 0V7h1v2h-1zm-6 3v-2h1v2H4zm2 0v-2h1v2H6zm4 0v-2h1v2h-1z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M11.327 10H4.673c-.598 0-.898-.775-.475-1.227L7.525 5.21a.638.638 0 01.948 0l3.33 3.562c.422.452.122 1.227-.476 1.227z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M4.673 6h6.654c.598 0 .898.775.475 1.227L8.475 10.79a.638.638 0 01-.948 0l-3.33-3.562C3.776 6.775 4.076 6 4.674 6z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M6 11.827V5.173c0-.598.775-.898 1.227-.475l3.562 3.327a.638.638 0 010 .948l-3.562 3.33c-.452.422-1.227.122-1.227-.476z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M10 5.173v6.654c0 .598-.775.898-1.227.475L5.21 8.975a.638.638 0 010-.948l3.562-3.33C9.225 4.276 10 4.576 10 5.174z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M6.95 10.364L13.314 4l1.414 1.414-6.364 6.364-1.414 1.414L2 8.242l1.414-1.414 3.536 3.536z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM6.95 9.95L4.12 7.12 2.707 8.536l4.243 4.242 1.414-1.414 4.95-4.95L11.899 5 6.95 9.95z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9.428 4.914l4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95L1.65 9.864 8.014 3.5l1.414 1.414z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M6.6 11.314l-4.95-4.95L3.064 4.95l4.95 4.95 4.95-4.95 1.414 1.414-6.364 6.364L6.6 11.314z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M11.314 9.428l-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L6.364 1.65l6.364 6.364-1.414 1.414z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M4.714 6.6l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414L3.3 8.014 4.714 6.6z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M2 2v12h12v1H1V2h1zm9 1v10H9V3h2zm1 2h2v8h-2V5zM8 6v7H6V6h2zM5 8v5H3V8h2z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M14.25 6.195A3.996 3.996 0 0116 9.5c0 2.203-1.797 4-4 4H3.89l-.109-.016A4.25 4.25 0 010 9.25a4.252 4.252 0 012.82-4A5.001 5.001 0 017.5 2c1.61 0 3.094.79 4.023 2.04a3.503 3.503 0 012.727 2.155zM12 11.5c1.102 0 2-.898 2-2 0-.93-.64-1.71-1.508-1.93 0-.023.008-.047.008-.07A1.5 1.5 0 0011 6c-.11 0-.219.016-.32.04h-.016c-.101.022-.195.062-.289.1A1.496 1.496 0 009.5 7.5h-1c0-.992.586-1.852 1.43-2.25A2.978 2.978 0 007.5 4a3 3 0 00-3 3v.023C4.414 7.016 4.336 7 4.25 7A2.25 2.25 0 002 9.25c0 1.156.875 2.125 2 2.25h8z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M13 3c1.102 0 2 .898 2 2v6c0 1.102-.898 2-2 2H3c-1.102 0-2-.898-2-2V5c0-1.102.898-2 2-2h10zM3 6h10V5H3v1zm10 5V8H3v3h10zm-1-1H9V9h3v1z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M11.352 6.648l-2-2L11 3l2 2-1.648 1.648zM6 12l-3 1 1-3 4.648-4.648 2 2L6 12z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M2 6.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8.817 3.479L7.335 2H3.183A2.177 2.177 0 001 4.17v6.66C1 12.025 1.975 13 3.183 13h9.634A2.177 2.177 0 0015 10.83V5.65l-.006-.161a2.178 2.178 0 00-2.177-2.01h-4zM3.04 4h3.355l1.526 1.533h5.037c.02 0 .041.02.041.05v5.366c0 .03-.02.051-.04.051H3.04c-.02 0-.04-.02-.04-.05v-6.9c0-.03.02-.05.04-.05z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M0 0h16v16H0z"
    }), n.createElement("path", {
      d: "M12 12.957V14H3v-1.043h9zm-7-5.74v5.218H4V7.217h1zm4 0v5.218H8V7.217h1zm-2 0v5.218H6V7.217h1zm4 0v5.218h-1V7.217h1zm.5-1.565c.276 0 .5.234.5.522a.511.511 0 01-.5.522h-8a.511.511 0 01-.5-.522c0-.288.224-.522.5-.522h8zM7.5 2c1.657 0 3 1.401 3 3.13h-6C4.5 3.401 5.843 2 7.5 2z",
      fill: "currentColor",
      fillRule: "nonzero"
    }));

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9 8.75H7l-.25-5h2.5l-.25 5zm-1 3.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM8 .5A7.499 7.499 0 00.5 8 7.5 7.5 0 108 .5z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9 9V7H6v2h1v2H6v2h4v-2H9V9zM8 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M13.474 9.55V12l2.525.001v1.634h-2.525v2.451H11.79v-2.451H9.265v-1.634h2.525V9.55h1.684zM7.999 1c2.21 0 3.998 1.752 3.998 4.525 0 .287-.021.568-.059.842l-.011.076c-.034.234-.085.46-.145.68a3.66 3.66 0 01-.051.185c-.035.116-.081.224-.123.336l.018-.016s-.161.473-.511 1.015a1.324 1.324 0 01-.044.069c-.267.4-.634.827-1.127 1.13l-.001-.002c-.458.31-1.026.552-1.712.699-.08-.001-.149-.003-.231-.003-.155 0-.298.002-.446.003a4.17 4.17 0 01-.297.019c-.041 0-.082.002-.122.003l-.025-.001c-3.806.076-5.109.712-5.109 3.512H.002l.001-.036C0 10.13 2.326 9.006 4.888 8.669 4.335 7.814 4 6.717 4 5.525 4 2.752 5.789 1 7.999 1zm0 2.01C6.788 3.01 6 4 6 5.526c0 1.61.937 3.016 1.999 3.016s1.999-1.405 1.999-3.016C9.998 4 9.217 3.01 7.999 3.01z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M14 4v7H2V4c0-1.102.898-2 2-2h8c1.102 0 2 .898 2 2zm-2 5V4H4v5h8zM0 12h16v1c0 .555-.445 1-1 1H1c-.555 0-1-.445-1-1v-1z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M12 7h2v2H4v4h8v-1h2v3H2V7h2V5c0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4v2zm-2 0V5c0-1.102-.898-2-2-2-1.102 0-2 .898-2 2v2h4zm2 4v-1h2v1h-2z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M10.625 9.823c.201.035.424.056.668.056l4.596 4.596-1.414 1.414-4.596-4.596c0-.244-.021-.467-.056-.668a6 6 0 11.802-.802zM6 10a4 4 0 100-8 4 4 0 000 8zm0-7a3 3 0 013 3H8a2 2 0 00-2-2V3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M15 7.094c0-.6-.315-1.118-.778-1.4V1.813c0-.222-.17-.813-.778-.813a.755.755 0 00-.485.178l-2.067 1.728a5.743 5.743 0 01-3.67 1.344H2.556C1.696 4.25 1 4.977 1 5.875v2.437c0 .898.696 1.625 1.556 1.625h.819a6.441 6.441 0 00-.053.813c0 1.01.225 1.964.62 2.817a.76.76 0 00.691.433H6.44c.633 0 1.013-.758.63-1.284a3.328 3.328 0 01-.636-1.966c0-.282.039-.553.107-.813h.682c1.329 0 2.632.478 3.67 1.345l2.067 1.727c.137.115.309.178.485.178.606 0 .778-.578.778-.812V8.494c.463-.282.778-.8.778-1.4zm-2.333 3.59l-.804-.67a7.26 7.26 0 00-4.64-1.702V5.875a7.26 7.26 0 004.64-1.7l.804-.672v7.181z",
      fill: "currentColor",
      fillRule: "nonzero"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M15 5H1V3h14v2zm0 4H1V7h14v2zm0 4H1v-2h14v2z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M6.074 12.068a4.5 4.5 0 005.994-5.994l-5.994 5.994zM3.945 9.954l6.01-6.009a4.5 4.5 0 00-6.009 6.009zM8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9.294 3l1.479 1.479-4.345 4.345.748.748 4.346-4.344L13 6.706V3H9.294zM4 4.588V12h7.412V7.765h-1.06v3.176H5.06V5.647h3.176V4.588H4z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M11.117 9.133C13.672 9.469 16 10.593 16 14.5h-2c0-2.992-1.5-3.5-6-3.5s-6 .508-6 3.5H0c0-3.906 2.328-5.031 4.89-5.367C4.337 8.28 4 7.188 4 6c0-2.758 1.79-4.5 4-4.5s4 1.742 4 4.5c0 1.188-.336 2.281-.883 3.133zM6 6c0 1.602.938 3 2 3 1.063 0 2-1.398 2-3 0-1.516-.781-2.5-2-2.5-1.21 0-2 .984-2 2.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M11.148 8.64a3.007 3.007 0 00-1.109 1.915A31.816 31.816 0 008 10.5c-4.5 0-6 .508-6 3.5H0c0-3.906 2.328-5.031 4.89-5.367C4.337 7.78 4 6.688 4 5.5 4 2.742 5.79 1 8 1s4 1.742 4 4.5c0 1.188-.336 2.281-.883 3.133.008.008.024.008.031.008zM8 8.5c1.063 0 2-1.398 2-3C10 3.984 9.219 3 8 3c-1.219 0-2 .984-2 2.5 0 1.602.938 3 2 3zm7 4h1V16h-6v-3.5h1V11c0-1.102.898-2 2-2 1.102 0 2 .898 2 2v1.5zM12 11v1.5h2V11c0-.547-.453-1-1-1-.547 0-1 .453-1 1z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9 7h4v2H9v4H7V9H3V7h4V3h2v4z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9 7V4H7v3H4v2h3v3h2V9h3V7H9z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 15.25A7.25 7.25 0 118 .75a7.25 7.25 0 010 14.5zM7.99 11a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM4.84 6.511h1.911c0-.234.026-.453.078-.657a1.58 1.58 0 01.24-.532c.109-.152.247-.273.417-.365.169-.09.37-.136.604-.136.347 0 .617.095.813.286.195.19.292.485.292.884.009.234-.032.429-.123.585-.092.156-.21.299-.358.429-.147.13-.308.26-.481.39s-.338.284-.494.462a2.686 2.686 0 00-.41.643c-.117.251-.188.563-.214.936v.585H8.87v-.494c.035-.26.12-.477.254-.65.134-.173.288-.327.461-.462.173-.134.357-.268.552-.402a2.532 2.532 0 00.936-1.176c.109-.27.163-.612.163-1.028a2.333 2.333 0 00-.702-1.625c-.251-.251-.583-.461-.995-.63C9.129 3.384 8.614 3.3 8 3.3c-.477 0-.908.08-1.293.24a2.87 2.87 0 00-.989.67 3.053 3.053 0 00-.636 1.014c-.152.39-.232.819-.241 1.287z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M2 10.14L1.14 5l1.462.398A5.998 5.998 0 018 2a5.975 5.975 0 015.172 2.977l-1.18 1.171A4.415 4.415 0 008 3.602a4.401 4.401 0 00-3.82 2.226l1.68.461L2 10.141zm11.398.47A5.991 5.991 0 018 14a5.975 5.975 0 01-5.172-2.977l1.18-1.171A4.415 4.415 0 008 12.398a4.401 4.401 0 003.82-2.226l-1.68-.461L14 5.859 14.86 11l-1.462-.39z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M12 2l3 4v9H1V2h11zm1 11V6.664L11 4H9v3H4V4H3v9h1v-3h5v3h4zM7 4v2h1V4H7zm1 8v-1H5v1h3zm0 2v-1H5v1h3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M15.5 8.5l-1.648.828-.118.453 1.008 1.54-.5.859-1.844-.11c-.101.117-.21.227-.328.328l.11 1.844-.86.5-1.539-1.008-.453.118L8.5 15.5h-1l-.828-1.648-.453-.118-1.54 1.008-.859-.5.11-1.844a3.252 3.252 0 01-.328-.328l-1.844.11-.5-.86 1.008-1.539-.118-.453L.5 8.5v-1l1.648-.828.118-.453-1.008-1.54.5-.859 1.844.11c.101-.118.21-.227.328-.328l-.11-1.844.86-.5 1.539 1.008.453-.118L7.5.5h1l.828 1.648.453.118 1.54-1.008.859.5-.11 1.844c.117.101.227.21.328.328l1.844-.11.5.86-1.008 1.539.118.453L15.5 7.5v1zM8 3.5c-.64 0-1.25.133-1.805.383L7.211 5.64c.25-.086.516-.141.789-.141s.54.055.79.14l1.015-1.757A4.372 4.372 0 008 3.5zm-2.664.883A4.494 4.494 0 003.53 7.5h2.016c.11-.54.406-1.008.797-1.36L5.336 4.384zM10.453 7.5h2.016a4.494 4.494 0 00-1.805-3.117L9.656 6.14c.39.351.688.82.797 1.359zM9 8c0-.555-.445-1-1-1-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1zm-5.469.5c.14 1.273.82 2.39 1.805 3.117L6.344 9.86A2.516 2.516 0 015.547 8.5H3.53zm7.133 3.117A4.494 4.494 0 0012.47 8.5h-2.016a2.516 2.516 0 01-.797 1.36l1.008 1.757zM8 12.5a4.5 4.5 0 001.805-.383L8.789 10.36A2.43 2.43 0 018 10.5a2.43 2.43 0 01-.79-.14l-1.015 1.757A4.5 4.5 0 008 12.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M3.74 2.19a.65.65 0 01.92 0l2.296 2.3a.65.65 0 11-.919.918L4.874 4.245v9.009a.65.65 0 11-1.3 0V4.196L2.36 5.409l-.081.068a.65.65 0 01-.839-.988zm7.296 10.023a.65.65 0 010 1.3h-2.58a.65.65 0 110-1.3zM12.14 8.89a.65.65 0 110 1.3H8.455a.65.65 0 110-1.3zm1.126-3.322a.65.65 0 010 1.3h-4.81a.65.65 0 110-1.3zm.868-3.322a.65.65 0 110 1.3H8.455a.65.65 0 110-1.3z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M4.175 2a.65.65 0 01.65.65v9.058l1.212-1.213a.65.65 0 01.92.919L4.66 13.713a.65.65 0 01-.92 0L1.44 11.414a.65.65 0 11.92-.919l1.162 1.164V2.65A.65.65 0 014.175 2zm9.958 10.213a.65.65 0 110 1.3H8.455a.65.65 0 110-1.3h5.678zm-.868-3.322a.65.65 0 110 1.3h-4.81a.65.65 0 110-1.3h4.81zm-1.126-3.322a.65.65 0 110 1.3H8.455a.65.65 0 110-1.3h3.684zm-1.102-3.322a.65.65 0 110 1.3H8.454a.65.65 0 110-1.3h2.582z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M0 0h16v16H0V0zm14 4V2H2v2h12zm0 10V5H2v9h12zM8 6v7H6V6h2zm5 0v4H9V6h4zM5 8v5H3V8h2zm8 3v2H9v-2h4z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 0c2.898 0 5 2.102 5 5v6h-2V5c0-1.93-1.344-3-3-3S5 3.07 5 5v6H3V5c0-2.898 2.102-5 5-5zM0 8c0-1.656.344-3 2-3v6C.344 11 0 9.656 0 8zm14-3c1.656 0 2 1.344 2 3s-.344 3-2 3V5zM2 13.79V11h1v2.21l2 1.142V14h2v2H5v-.492l-3-1.719z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M5 0h6v1H5zM5 1h1v1H5zM10 1h1v1h-1zM1 2h14v2H1zM2 5h12v9a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm2 1v8h1V6H4zm3.5 0v8h1V6h-1zM11 6v8h1V6h-1z"
    }));

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M14.18 2.001c-1.333.077-3.98.355-5.615 1.365a.378.378 0 00-.176.324v8.934c0 .283.307.463.566.331 1.681-.855 4.113-1.088 5.315-1.152a.762.762 0 00.73-.753V2.755a.765.765 0 00-.82-.754zM7.434 3.366C5.8 2.356 3.153 2.078 1.82 2.001A.765.765 0 001 2.755v8.296c0 .398.32.73.73.752 1.203.064 3.636.298 5.317 1.153.258.131.564-.048.564-.33v-8.94a.37.37 0 00-.176-.32z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M10.752 10.495a.65.65 0 00-.918 0l-1.211 1.21v-7.46l1.164 1.163a.65.65 0 10.918-.919L8.409 2.191a.65.65 0 00-.92 0L5.19 4.489a.65.65 0 00.918.92l1.215-1.215v.176c0 .005-.004.01-.004.016v7.273l-1.163-1.164a.65.65 0 00-.92.92l2.298 2.298a.65.65 0 00.919 0l2.299-2.298a.65.65 0 000-.92",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M7.527 1.21a.638.638 0 01.948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 01-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 12.5l.144.007A1.5 1.5 0 019.5 13.999l-.007.145A1.5 1.5 0 018 15.5l-.144-.007A1.501 1.501 0 018 12.5zm0-5.999l.144.007A1.5 1.5 0 019.5 8l-.007.144A1.5 1.5 0 018 9.5l-.144-.007A1.5 1.5 0 018 6.501zM8 .5l.144.007C8.904.58 9.5 1.22 9.5 2l-.007.144A1.5 1.5 0 018 3.5l-.144-.007A1.5 1.5 0 018 .5z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M9.307.765l6.435 11.44a1.5 1.5 0 01-1.307 2.236H1.565a1.5 1.5 0 01-1.308-2.236L6.693.765a1.5 1.5 0 012.614 0zM6.75 4.368l.25 5h2l.25-5h-2.5zm1.25 8.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M13.303 4.11L9.413 8l3.89 3.89-1.414 1.413L8 9.413l-3.888 3.89-1.414-1.414L6.585 8 2.697 4.111 4.11 2.697l3.888 3.888 3.89-3.888 1.414 1.414z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0);

    function l() {
      return (l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};

      var r,
          n,
          l = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            l = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
        }

        return l;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
        }
      }

      return l;
    }

    var a = n.createElement("path", {
      d: "M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9.414 8l2.475-2.475-1.414-1.414L8 6.586 5.525 4.11 4.111 5.525 6.586 8 4.11 10.475l1.414 1.414L8 9.414l2.475 2.475 1.414-1.414L9.414 8z",
      fill: "currentColor",
      fillRule: "evenodd"
    });

    t.default = function (e) {
      var t = e.title,
          r = e.titleId,
          o = i(e, ["title", "titleId"]);
      return n.createElement("svg", l({
        width: 16,
        height: 16,
        role: "img",
        viewBox: "0 0 16 16",
        "aria-labelledby": r
      }, o), t ? n.createElement("title", {
        id: r
      }, t) : null, a);
    };
  }]);
});